






































































import { mapGetters, mapState, mapMutations } from 'vuex'
import {
  faSync,
  faEnvelopeOpen,
  faCog,
  faUser,
  faTimes,
  faSearch,
  faTrash
} from '@fortawesome/free-solid-svg-icons'
import CMiniMessageThreadEntry from '~/components/shared/configurable/message/CMiniMessageThreadEntry.vue'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { DECREASE_MESSAGES_COUNT } from '~/store/modules/shared/classifieds/form/mutation-types'
// TODO: Shouldn't import from car here
import HasMessagesAlert from '~/components/car/classifieds/view/partials/HasMessagesAlert'
import { USER_NS } from '~/store/modules/shared/user/state'
import { changeFaviconNotification } from '~/utils/dom'
import { APP_NS } from '~/store/modules/shared/app/state'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { SET_HAS_UNREAD_MESSAGES } from '~/store/modules/shared/classifieds/view/mutation-types'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import CPagination from '~/components/shared/configurable/pagination/CPagination.vue'
import { formatMessageThreadsRows } from '~/utils/messages'
import { ClassifiedOfferEntry } from '~/models/classified/offers'
import { defineComponent } from '@nuxtjs/composition-api'
import { vue3Set } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CPagination,
    CMiniMessageThreadEntry,
    HasMessagesAlert
  },
  props: {
    classified: { type: Number, required: false, default: null },
    inEdit: { type: Boolean, required: false, default: false },
    fullView: { type: Boolean, required: false, default: false },
    threadOpened: { type: Boolean, required: false, default: false },
    goToMessagesOnLoad: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      icons: {
        sync: faSync,
        trash: faTrash,
        cog: faCog,
        times: faTimes,
        search: faSearch,
        user: faUser,
        envelopeOpen: faEnvelopeOpen
      },
      thread_pageNum: 1,
      message_threads: null,
      threadPagination: {},
      fetchStarted: true,
      ownedDealers: [],
      activeThreads: [],
      sitekeyv3: process.env.GRECAPTCHA_V3_SITE_KEY
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      hasUnreadMessages: state => state.hasUnreadMessages,
      isFloatingButtonsVisible: state =>
        state.isFloatingButtonsMessagePhoneVisible
    }),
    ...mapState(USER_NS, {
      userType: 'type',
      userActualName: 'name',
      username: 'username',
      userId: 'id'
    }),
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin'
    }),
    ...mapGetters({
      userIsAdminOrOwner: 'classifieds/view/userIsAdminOrOwner'
    }),
    ...mapGetters(APP_NS, {
      isCar: 'isCar'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),

    classifiedMine() {
      // if we are dispatched
      if (
        process.client &&
        window.frameElement &&
        window.frameElement.getAttribute('clsfd-mine')
      ) {
        return window.frameElement.getAttribute('clsfd-mine') === 'True'
      }

      // if we are in car2
      if (this.inEdit || this.userIsAdminOrOwner) {
        return true
      }

      return false
    },
    unreadThreadsCount() {
      if (this.message_threads) {
        return this.message_threads.filter(r => {
          return r.read === false
        }).length
      }

      return 0
    },
    mailbox() {
      return this.classifiedMine ? 'inbox' : 'outbox'
    },
    paginationPages() {
      if (this.threadPagination) {
        return Math.ceil(
          this.threadPagination.total / this.threadPagination.per_page
        )
      }

      return 0
    },
    threadsExist() {
      return this.message_threads && this.message_threads.length > 0
    },
    showPagination() {
      if (typeof this.threadPagination === 'undefined') {
        return false
      }
      return this.threadPagination.total > this.threadPagination.per_page
    }
  },
  watch: {
    unreadThreadsCount(val) {
      this.$nextTick(() => {
        this.updateHasUnread(val > 0)
      })
    }
  },
  updated() {
    this.$emit('updated')
  },
  mounted() {
    this.fetch()
  },
  methods: {
    ...mapMutations(CLASSIFIED_FORM_NS, {
      decreaseMessagesCount: DECREASE_MESSAGES_COUNT
    }),
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setHasUnreadMessages: SET_HAS_UNREAD_MESSAGES
    }),
    updateHasUnread(change) {
      if (process.client && window.frameElement) {
        this.postFaviconNotification(change)
      } else {
        try {
          changeFaviconNotification(change)
        } catch (error) {
          this.$logger.captureError(error)
        }
        this.setHasUnreadMessages(change)
      }
    },
    postFaviconNotification(status) {
      window.parent.postMessage(
        {
          event_id: 'favicon-notification',
          data: {
            status
          }
        },
        '*'
      )
    },
    openFirstUnread() {
      if (this.unreadThreadsCount === 1) {
        for (let i = 0; i < this.message_threads.length; i++) {
          if (!this.message_threads[i].read) {
            this.addActiveThreadOnly(this.message_threads[i].id)
            return
          }
        }
      }
    },
    fetch(silent = false) {
      this.message_threads = ''
      this.fetchStarted = true

      this.$axios
        .get('/api/account/messages/', {
          params: {
            mailbox: this.mailbox,
            pg: this.thread_pageNum,
            classified: this.classified
          }
        })
        .then(response => {
          if (response.status === 200) {
            if (response.data.data.owned_dealers && !silent) {
              this.ownedDealers = response.data.data.owned_dealers
            }

            if (response.data.data.message_threads.rows.length) {
              if (!silent) {
                this.$emit('has-messages')
              }

              this.message_threads = formatMessageThreadsRows(
                response.data.data.message_threads.rows
              )

              this.threadPagination =
                response.data.data.message_threads.pagination

              if (
                this.thread_pageNum > this.paginationPages &&
                this.thread_pageNum > 1
              ) {
                // redo search with correct page
                this.onThreadPageChange(this.paginationPages)
              }
            }

            this.fetchStarted = false

            this.$nextTick(function() {
              this.$emit('fetched')
              if (this.message_threads) {
                const currentUserInThreads = Boolean(
                  this.message_threads.filter(m => {
                    return m.participant.id === this.userId
                  }).length
                )

                if (currentUserInThreads) {
                  this.$emit('what-to-show', 'messages-only')
                }
              }
            })
          }
        })
        .catch(_error => {
          this.$emit('no-messages')
          this.fetchStarted = false
        })
    },
    refetch() {
      if (!this.fetchStarted) {
        this.message_threads = ''
        this.fetchStarted = true
        setTimeout(() => {
          this.fetch()
        }, 1000)
      }
    },
    messagesRead(thread) {
      // post read messages
      this.$axios
        .post(`/api/account/messages/${thread.id}/read/`)
        .then(response => {
          if (response.status === 200) {
            if (response.data.data.message_ids.length) {
              thread.read = true
              this.decreaseMessagesCount()
            }
          }
        })
        .catch(_error => {})
    },
    onThreadClick(_e) {},
    onThreadPageChange(pageNum) {
      this.thread_pageNum = pageNum
      this.fetch()
    },
    updateThread(id, newThreadInfo) {
      for (let i = 0; i < this.message_threads.length; i++) {
        if (this.message_threads[i] === id) {
          if (newThreadInfo.clsfd_title) {
            this.message_threads[i].clsfd_title = newThreadInfo.clsfd_title
          }

          if (newThreadInfo.participant) {
            this.message_threads[i].participant = newThreadInfo.participant
          }

          if (newThreadInfo.name) {
            this.message_threads[i].name = newThreadInfo.name
          }

          if (newThreadInfo.read) {
            this.message_threads[i].read = newThreadInfo.read
          }

          if (newThreadInfo.owner) {
            this.message_threads[i].owner = newThreadInfo.owner
          }

          if (newThreadInfo.clsfd_id) {
            this.message_threads[i].clsfd_id = newThreadInfo.clsfd_id
          }

          if (newThreadInfo.last_message_ts) {
            this.message_threads[i].last_message_ts =
              newThreadInfo.last_message_ts
          }

          return
        }
      }
    },
    addActiveThreadOnly(id) {
      this.activeThreads = [id]
    },
    addActiveThread(id) {
      if (!this.activeThreads.includes(id)) {
        this.activeThreads.push(id)
      }
    },
    removeActiveThread(id) {
      if (this.activeThreads.includes(id)) {
        this.activeThreads.splice(this.activeThreads.indexOf(id), 1)
      }
    },
    deleteThread(id) {
      this.$axios
        .delete('/api/account/messages/', {
          data: {
            ids: [id]
          }
        })
        .then(response => {
          if (response.status === 200) {
            const respThreads = response.data.data.message_threads

            for (let i = 0; i < this.message_threads.length; i++) {
              for (let j = 0; j < respThreads.length; j++) {
                if (respThreads[j].id === this.message_threads[i].id) {
                  if (respThreads[j].code === 200) {
                    this.message_threads.splice(i, 1)

                    this.$nextTick(function() {
                      setTimeout(() => {
                        this.fetch(true)
                      }, 500)
                    })
                  } else {
                    this.$snackbar.error(this.$t('something went wrong'))
                  }
                }
              }
            }
          } else {
            this.$snackbar.error(this.$t('something went wrong'))
          }
        })
        .catch(_error => {})
    },
    updateOffer(offerIndex, updatedOffer: ClassifiedOfferEntry) {
      if (this.message_threads && this.message_threads[offerIndex]?.offer) {
        const selectedThread = { ...this.message_threads[offerIndex] }
        selectedThread.offer = updatedOffer
        vue3Set(this.message_threads, offerIndex, selectedThread)
      }
    }
  }
})
